import { Link } from "react-router-dom";

const linkCls = "font-semibold text-slate-600 hover:text-emerald-700 underline-offset-4 hover:underline transition-colors";

export const LegalFooter = ({ className = "" }) => (
  <footer className={`flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-slate-500 ${className}`} data-testid="legal-footer">
    <span>© {new Date().getFullYear()} MileageTax</span>
    <Link to="/privacy" className={linkCls} data-testid="footer-privacy-link">Privacy Policy</Link>
    <Link to="/terms" className={linkCls} data-testid="footer-terms-link">Terms of Service</Link>
  </footer>
);
